/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Styles
import './styles/IconRating.scss';

const propTypes = {
  themeName: PropTypes.string,
  readonly: PropTypes.bool,
  reviewValue: PropTypes.number,
  onChange: PropTypes.func,
};

class IconRating extends PureComponent {
  state = {
    numberOfIcons: 5,
    lastHighlighted: 0,
    themes: {
      overall: {
        icon: 'star',
        color: 'hsl(50, 93%, 59%)',
      },
      thumbs: {
        icon: 'thumbs-up',
        color: 'hsl(154, 82%, 33%)',
      },
      price: {
        icon: 'money',
        color: 'hsl(154, 82%, 33%)',
      },
      quality: {
        icon: 'smile-o',
        color: 'hsl(154, 82%, 33%)',
      },
    },
  };

  rate = rating => {
    const { onChange, readonly, themeName } = this.props;
    if (!readonly && typeof onChange === 'function') {
      onChange({ themeName, rating });
    }
  };

  highlight = highlight => {
    const { readonly } = this.props;
    if (!readonly) {
      this.setState({ lastHighlighted: highlight });
    }
  }

  renderIcons = () => {
    const { reviewValue, themeName } = this.props;
    const { numberOfIcons, themes, lastHighlighted } = this.state;

    const icons = [];
    for (let i = 0; i < numberOfIcons; i++) {
      const classname = classNames('icon', themeName, {
        // if lastHighlighted > 0 use that, otherwise reviewValue when comparing
        highlighted: i < (lastHighlighted || reviewValue),
      });
      icons.push(
        <button
          onClick={() => this.rate(i + 1)}
          onMouseEnter={() => this.highlight(i + 1)}
          onMouseLeave={() => this.highlight(0)}
          key={`rating-${themeName}-${i}`}
        >
          <span
            styleName={classname}
            className={`fa fa-${themes[themeName].icon} fa-2x`}
          />
        </button>
      );
    }
    return icons;
  }

  render() {
    const { readonly } = this.props;

    const classname = classNames('IconRating', { readonly });
    return (
      <div styleName={classname}>
        {this.renderIcons()}
      </div>
    );
  }
}

IconRating.propTypes = propTypes;

export default IconRating;
